import { render } from "./ErrorView.vue?vue&type=template&id=9632ee6a"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Mindscan\\online-quiz-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__